import React, { useMemo } from 'react';
import { useAccess } from '../../Context/AccessContext';

const HeaderItem = ({ acesso=0, route='', nome='', handleNavigate=()=>{} }) => {

    const { getAccess, accessLoaded } = useAccess();

    const access = useMemo(() => accessLoaded && getAccess(acesso), [accessLoaded, getAccess, acesso]);

    if(access?.opcao_menu){
        return(
            <li><button onClick={e => handleNavigate(e, route)} onContextMenu={() => { window.open(route); }}>{nome}</button></li>
        );
    }
    else {
        return null;
    }
};

export default HeaderItem;